import { HarvestTypes, PassOrFail } from "@gtpl/shared-models/common-models"
import { CompanyTypeEnum } from "@gtpl/shared-models/masters"

export class GrnIdReq{
    grnId:number
    createdUser:string
    mainBatchNumber?:string;
    reweighmentBillTo?:CompanyTypeEnum
    referenceNum?: number
    plantId?:number
    vehicleNumber?:string
    sealNumber?:string
    reweighmentDate?:Date
    supervisor?:number
    countWiseBatchNum?:CountWiseBatchNumberReq[]

    constructor(grnId:number,createdUser:string,mainBatchNumber?:string,reweighmentBillTo?:CompanyTypeEnum,referenceNum?: number,plantId?:number,vehicleNumber?:string,sealNumber?:string,
        reweighmentDate?:Date,
        supervisor?:number,countWiseBatchNum?:CountWiseBatchNumberReq[]){
        this.grnId = grnId
        this.createdUser = createdUser
        this.mainBatchNumber = mainBatchNumber
        this.reweighmentBillTo = reweighmentBillTo
        this.referenceNum = referenceNum
        this.plantId = plantId
        this.vehicleNumber = vehicleNumber
        this.sealNumber=sealNumber
        this.reweighmentDate=reweighmentDate
        this.supervisor=supervisor
        this.countWiseBatchNum = countWiseBatchNum
    }
}

export class CountWiseBatchNumberReq{
    count : number;
    batchNumber : string;
    antibioticTestResult?:PassOrFail

    constructor(count:number,batchNumber:string,antibioticTestResult?:PassOrFail){
        this.count = count
        this.batchNumber = batchNumber
        this.antibioticTestResult = antibioticTestResult
    }
}